import type { FontsType } from './interfaces/fonts.type';

export const Fonts: FontsType = {
  primary: {
    regular: {
      fontFamily: 'System',
      fontWeight: '500',
    },
    italic: {
      fontFamily: 'System',
      fontWeight: '400',
      fontStyle: 'italic',
    },
    light: {
      fontFamily: 'System',
      fontWeight: '300',
    },
    lightItalic: {
      fontFamily: 'System',
      fontWeight: '300',
      fontStyle: 'italic',
    },
    bold: {
      fontFamily: 'System',
      fontWeight: '700',
    },
    boldItalic: {
      fontFamily: 'System',
      fontWeight: '800',
      fontStyle: 'italic',
    },
  },
  secondary: {
    regular: {
      fontFamily: 'System',
      fontWeight: '400',
    },
    italic: {
      fontFamily: 'System',
      fontWeight: '400',
      fontStyle: 'italic',
    },
    light: {
      fontFamily: 'System',
      fontWeight: '300',
    },
    lightItalic: {
      fontFamily: 'System',
      fontWeight: '300',
      fontStyle: 'italic',
    },
    bold: {
      fontFamily: 'System',
      fontWeight: '800',
    },
    boldItalic: {
      fontFamily: 'System',
      fontWeight: '800',
      fontStyle: 'italic',
    },
  },
};
